import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import InputButton from "../../../UI/InputButton";

const OldCard = ({
    backClick,
    onSelectAnswer,
    setOldCard,
}) => {
    const [checkedOne, setCheckedOne] = useState("unchecked");
    const [checkedTwo, setCheckedTwo] = useState("unchecked");

    const optionHandle = async (e) => {
        if (e.target.value === "236") {
            setCheckedOne("checked");
            setCheckedTwo("unchecked");
            onSelectAnswer(e);
            setOldCard(236);
        } else {
            setCheckedTwo("checked");
            setCheckedOne("unchecked");
            onSelectAnswer(e);
            setOldCard(237);
        }

    }
    return (
        <>
            <div className={`question-content mt-0 scale-down-ver-center   px-3 py-lg-3 py-md-3 py-sm-2 py-2 pb-3`} >
                <div className="row">
                    <div className="col-6">
                        <div className=" mb-2">
                            <button
                                type="button"
                                className={`btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn  ${checkedTwo}`}
                                onClick={optionHandle}
                                value="236"
                                name="oldcard"
                                id="nextscroll"
                                data-quest-id={81}
                                data-ans-id={236}
                                data-ans-label={null}
                            >Yes
                            </button>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className=" mb-2">

                            <button
                                type="button"
                                className={`btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 noissue  ${checkedOne}`}
                                onClick={optionHandle}
                                value="237"
                                name="oldcard"
                                id="nextscroll"
                                data-quest-id={81}
                                data-ans-id={237}
                                data-ans-label={null}
                            >No
                            </button>
                        </div>
                    </div>
                </div>
                <p className="text-center bck-marwid">
                    <button
                        name="btn_qest_76"
                        className="btn btn-secondary backbtn1a"
                        id=""
                        value=""
                        type="button"
                        onClick={backClick}

                    >Go Back</button>
                </p>
            </div>

        </>
    )
}
export default OldCard;